import { render, staticRenderFns } from "./c-patients-grid.vue?vue&type=template&id=3593009c&"
import script from "./c-patients-grid.vue?vue&type=script&lang=js&"
export * from "./c-patients-grid.vue?vue&type=script&lang=js&"
import style0 from "./c-patients-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports